"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./utils");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _SimpleFilterSelector = _interopRequireDefault(require("../overview/filters/SimpleFilterSelector"));

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var _excluded = ["id", "name", "customClassName", "title", "isDropdownOpen", "toggleDropdown", "resetDropdown", "items", "selectedItems", "onClear", "onChange", "isLoading"];

var DashboardSimpleFilter = function DashboardSimpleFilter(_ref) {
  var id = _ref.id,
      name = _ref.name,
      customClassName = _ref.customClassName,
      title = _ref.title,
      isDropdownOpen = _ref.isDropdownOpen,
      toggleDropdown = _ref.toggleDropdown,
      resetDropdown = _ref.resetDropdown,
      items = _ref.items,
      selectedItems = _ref.selectedItems,
      onClear = _ref.onClear,
      onChange = _ref.onChange,
      isLoading = _ref.isLoading,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var placeholderAdditionalText = (0, _utils.getPlaceholderText)(items, selectedItems);
  var applyButtonProps = otherProps['data-track-type'] ? {
    'data-track-type': otherProps['data-track-type'],
    'data-element-name': "".concat(otherProps['data-element-name'], " apply button")
  } : {};
  var cancelButtonProps = otherProps['data-track-type'] ? {
    'data-track-type': otherProps['data-track-type'],
    'data-element-name': "".concat(otherProps['data-element-name'], " cancel button")
  } : {};
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)("filter-option-".concat(customClassName), 'filter-option')
  }, (0, _preact.h)(_Button.default, (0, _extends2.default)({
    disabled: isLoading,
    title: (0, _preact.h)(FilterTitle, {
      title: title,
      onClear: onClear,
      placeholderAdditionalText: placeholderAdditionalText,
      isDropdownOpen: isDropdownOpen,
      selectedItems: selectedItems
    }),
    size: "medium",
    className: (0, _classnames.default)("".concat(customClassName, "-open-button"), 'filter-option-button', {
      'dropdown-open': isDropdownOpen
    }),
    onClick: function onClick() {
      return toggleDropdown(!isDropdownOpen);
    }
  }, otherProps)), isDropdownOpen && (0, _preact.h)("div", {
    className: "overview__filters-box-container"
  }, (0, _preact.h)("div", {
    className: "overview__filters-box"
  }, (0, _preact.h)(_SimpleFilterSelector.default, {
    id: id,
    name: name,
    isSearchable: true,
    items: items,
    selectedFilterItems: selectedItems
  }, function (_ref2) {
    var isApplyButtonDisabled = _ref2.isApplyButtonDisabled,
        data = _ref2.data;
    return (0, _preact.h)("div", null, (0, _preact.h)("hr", null), (0, _preact.h)("div", {
      className: "overview__filters-box-buttons"
    }, (0, _preact.h)(_Button.default, (0, _extends2.default)({
      size: "small",
      variant: "brand",
      title: "Apply",
      disabled: isApplyButtonDisabled,
      onClick: function onClick() {
        return onChange(data);
      }
    }, applyButtonProps)), (0, _preact.h)(_Button.default, (0, _extends2.default)({
      size: "small",
      title: "Cancel",
      onClick: resetDropdown
    }, cancelButtonProps))));
  }))));
};

var FilterTitle = function FilterTitle(_ref3) {
  var title = _ref3.title,
      placeholderAdditionalText = _ref3.placeholderAdditionalText,
      onClear = _ref3.onClear,
      selectedItems = _ref3.selectedItems,
      isDropdownOpen = _ref3.isDropdownOpen;
  return (0, _preact.h)("div", null, (0, _preact.h)("span", {
    className: (0, _classnames.default)('dropdown-placeholder-text', {
      'filter-dropdown-open': isDropdownOpen
    })
  }, ' ', title), (0, _preact.h)("span", {
    className: (0, _classnames.default)('dropdown-selected-placeholder', {
      'filter-dropdown-open': isDropdownOpen
    })
  }, placeholderAdditionalText), selectedItems.length > 0 && (0, _preact.h)("span", {
    className: "icon-cancel-wrapper",
    onClick: function onClick(e) {
      return onClear(e);
    }
  }, (0, _preact.h)(_assets.default, {
    icon: "cancel",
    customClass: "icon-cancel",
    height: 16,
    width: 16
  }), ' '));
};

var _default = DashboardSimpleFilter;
exports.default = _default;